export type SendMessageRes = Record<string, never>;
